// 定制版本号 + 更新日志（前端硬编码）
// 每次迭代：改 CUSTOM_VERSION + 在 CHANGELOG 顶部追加一条，重新 build
export const CUSTOM_VERSION = 'v1.0.1';
export const UPSTREAM_VERSION = '4.15.1';
export const RELEASE_DATE = '2026-08-10';

export const CHANGELOG = [
  {
    version: 'v1.0.1',
    date: '2026-08-10',
    note: '留电来源报表上线 + widget 自动展开与建会话解耦 + 风暴报表/版本页全宽布局',
    sections: [
      {
        title: '报表',
        items: [
          '新增「留电来源」报表：按归属者 × 来源URL 统计已留联客户数',
          '支持归属者多选、按留电时间（北京时区）日期筛选、表头排序',
          '风暴报表、版本页改为与其他菜单一致的全宽布局',
        ],
      },
      {
        title: 'widget 定制',
        items: [
          '自动展开聊天面板与自动建会话解耦（关闭建会开关仍可自动弹窗）',
          '后台收件箱始终显示自动弹窗嵌入代码',
        ],
      },
      {
        title: '修复',
        items: [
          '修复风暴报表接口路由缺失导致加载失败',
          '修复留电来源报表授权（仅管理员可见）',
        ],
      },
    ],
  },
  {
    version: 'v1.0.0',
    date: '2026-08-07',
    note: '初版基线：当前所有已上线定制功能',
    sections: [
      {
        title: 'AI 客服与自动跟进',
        items: [
          'AgentBot（ZKGX AI）自动回复，显示收件箱名 + 头像',
          '访客无响应 40s 自动跟进（per-inbox 开关 / 文案 / 秒数）',
          '访客离开 / 重开 widget 通知',
        ],
      },
      {
        title: '留电与尘锋推送',
        items: [
          '留电自动推尘锋（手机 / 微信 / 固话 / 邮箱）',
          '尘锋字段类型修正（网站地址 / 对话记录等）',
          '回访客户自动合并去重，避免推空线索',
          '固定电话字段抓取',
        ],
      },
      {
        title: '联系人与名片管理',
        items: [
          '手机号脱敏统一把关（can_view_phone?）',
          '归属客服按收件箱动态显示',
          '名片状态色块、去重导出、留联 / 未留联筛选',
          '访客浏览轨迹（右侧 tab + 10s 轮询）',
        ],
      },
      {
        title: '会话与稳定性',
        items: [
          '客服全收件箱可见 + 轮询兜底（防 WS 掉线）',
          '会话转圈 / 切 tab 显示不全 / 消息翻倍等修复',
        ],
      },
      {
        title: 'widget 定制',
        items: [
          '左侧图片浮标（per-inbox 开关 + 自定义图）',
          '欢迎语定制、访客强制归属 inbox 成员',
        ],
      },
      {
        title: '风暴防护与报表',
        items: [
          'webwidget_triggered 短路，防会话风暴',
          '/widget 机器人 UA 过滤',
          '风暴报表（每日新增 / 拦截 / 清理）',
          '定期清孤儿联系人 / 会话',
        ],
      },
    ],
  },
];
